import React from "react";
import {
  Magnifier,
  MOUSE_ACTIVATION,
  TOUCH_ACTIVATION,
} from "react-image-magnifiers";
import styled from "styled-components";

interface ImageWithZoomProps {
  imageSrc: string;
  largeImageSrc?: string;
}

const StyledMagnifier = styled(Magnifier)`
  height: 100%;
  width: 100%;
  & > div > img {
    object-fit: contain;
    max-height: 100vh;
  }
`;

const ImageWithZoom: React.FunctionComponent<ImageWithZoomProps> = ({
  imageSrc,
  largeImageSrc,
}) => {
  return (
    <StyledMagnifier
      imageSrc={imageSrc}
      largeImageSrc={largeImageSrc}
      mouseActivation={MOUSE_ACTIVATION.CLICK}
      touchActivation={TOUCH_ACTIVATION.DOUBLE_TAP}
      imageAlt="Vehicle image with zoom"
    />
  );
};

export default ImageWithZoom;
